import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useContact } from "../utils/ContactContext";

export default function Home(props) {
  const { setOpen } = useContact();
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div className="home2-banner-section mb-120">
              <div className="video-area">
               <video
  autoPlay
  muted
  loop
  playsInline
  style={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100vw",
    height: "56.25vw",
    minHeight: "100vh",
    minWidth: "177.77vh",
    border: "none",
    pointerEvents: "none",
  }}
>
  <source src="/assets/video/home-bananer.mp4" type="video/mp4" />
</video>

                {/* Overlay — 0.5 kam karo zyada video dikhane ke liye */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    zIndex: 1,
                  }}
                />
              </div>
              <div className="banner-wrapper-wrap">
                <div className="banner-wrapper">
                  <div className="left-content">
                    <h1 style={{ textAlign: "left" }}>
                      Your Local Partner for Custom Software in Melbourne
                    </h1>
                    <div className="button-area">
                      <a
                        className="primary-btn1"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpen(true);
                        }}
                      >
                        <span>
                          Get a Free Consultation
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                            </g>
                          </svg>
                        </span>
                        <span>
                          Get a Free Consultation
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                            </g>
                          </svg>
                        </span>
                      </a>
                    </div>
                  </div>
                  <div className="right-content">
                    <div className="counter-wrap">
                      <div className="counter-area">
                        <div className="counter-content">
                          <p>
                            Project <br />
                            Completed
                          </p>
                          <div className="number">
                            <h2 className="counter">1</h2>
                            <span>K+</span>
                          </div>
                        </div>
                      </div>
                      <div className="counter-area two">
                        <div className="counter-content">
                          <p>
                            Customer <br />
                            Satisfaction
                          </p>
                          <div className="number">
                            <h2 className="counter">98</h2>
                            <span>%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home4-banner-section">
              <div class="banner-wrapper">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="banner-content text-center">
                        <span class="batch">Build Your Software Today!</span>
                        <h1>Solving business challenges together, locally</h1>
                        <p>
                          Insight Wide is an innovative provider of business
                          management and analytics solutions, delivering
                          powerful tools that help both local and global
                          organizations grow and perform efficiently..
                        </p>
                        <div class="button-area">
                          <a
                            class="primary-btn1"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            <span>
                              Start Your Project
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g>
                                  <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                </g>
                              </svg>
                            </span>
                            <span>
                              Start Your Project
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g>
                                  <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                </g>
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row gy-4 justify-content-between align-items-center">
                    <div class="col-lg-4 col-md-6 col-sm-7">
                      <div class="banner-left-content">
                        <div class="author-area">
                          <ul class="author-img-grp">
                            <li>
                              <img
                                src="assets/image/start-up/counter-people-img1.png"
                                alt=""
                              />
                            </li>
                            <li>
                              <img
                                src="assets/image/start-up/counter-people-img2.png"
                                alt=""
                              />
                            </li>
                            <li>
                              <img
                                src="assets/image/start-up/counter-people-img3.png"
                                alt=""
                              />
                            </li>
                          </ul>
                          <h2>
                            we’ve already{" "}
                            <strong>
                              <span class="counter_number">20</span>k+
                            </strong>
                            active users
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-5">
                      <div class="banner-right-content">
                        <div class="counter-area">
                          <h2>
                            <strong class="counter_number">12</strong>
                            <sup>+</sup>
                          </h2>
                          <span>
                            year of <br /> experineces
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="home4-banner-video">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  src="/assets/banner-2.mp4"
                ></video>
              </div>
            </div>
            <div class="home4-banner-video-full mb-120"></div>

            <div className="about-us-section home2-about-us mb-120">
              <div className="container">
                <div className="about-us-content-wrap">
                  <div className="row mb-80 gy-5">
                    <div className="col-lg-4">
                      <div className="left-about-area">
                        <div className="section-title">
                          <span>About Softro</span>
                        </div>
                        <div className="about-image">
                          <img
                            src="assets/image/start-up2/about-us-award.gif"
                            alt=""
                          />
                          <div className="award-img">
                            <img
                              src="assets/image/start-up2/award-img.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="right-about-area">
                        <div className="section-title">
                          <h2 className="text-anim">
                            Looking for subscription-based software or a fully
                            custom solution? We’re here to support you.
                          </h2>
                        </div>
                        <div
                          className="counter-area-wrap fade_anim"
                          data-delay=".2"
                          data-fade-from="left"
                        >
                          <div className="author-area">
                            <ul className="author-img-grp">
                              <li>
                                <img
                                  src="assets/image/start-up/counter-people-img1.png"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  src="assets/image/start-up/counter-people-img2.png"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  src="assets/image/start-up/counter-people-img3.png"
                                  alt=""
                                />
                              </li>
                            </ul>
                            <h3>
                              we’ve already{" "}
                              <strong>
                                <span className="counter_number">20</span>k+
                              </strong>
                              active users
                            </h3>
                          </div>
                        </div>
                        <div
                          className="video-and-content-area fade_anim"
                          data-delay=".2"
                          data-fade-from="right"
                        >
                          <div className="content">
                            <p>
                              We are a team of skilled developers based in
                              Melbourne, Australia, delivering reliable software
                              solutions to local businesses. From
                              subscription-based platforms to fully customized
                              systems
                            </p>
                            <a
                              className="primary-btn1"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setOpen(true);
                              }}
                            >
                              <span>
                                Get a Free Consultation
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g>
                                    <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                  </g>
                                </svg>
                              </span>
                              <span>
                                Get a Free Consultation
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g>
                                    <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                  </g>
                                </svg>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="counter-wrap">
                    <div className="row gy-sm-5 gy-4 gx-xl-4 gx-2">
                      <div className="col-lg-3 col-sm-6 d-flex justify-content-sm-center divider">
                        <div className="single-countdown">
                          <div className="number">
                            <h2 className="counter_number">12</h2>
                          </div>
                          <span>years of experience</span>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 d-flex justify-content-sm-center divider">
                        <div className="single-countdown">
                          <div className="number">
                            <h2 className="counter_number">05</h2>
                          </div>
                          <span>Industry Awards</span>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 d-flex justify-content-sm-center divider">
                        <div className="single-countdown">
                          <div className="number">
                            <h2 className="counter_number">2</h2>
                            <span>K</span>
                          </div>
                          <span>Global Clients Served</span>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 d-flex justify-content-lg-end justify-content-sm-center">
                        <div className="single-countdown">
                          <div className="number">
                            <h2 className="counter_number">3</h2>
                            <span>K</span>
                          </div>
                          <span>Users Engaged</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home5-banner-section">
              <div
                className="banner-content-wrapper"
                style={{ paddingTop: "50px" }}
              >
                <div class="container one">
                  <div class="banner-content text-center">
                    <h1>
                      All energy business workflows managed in one platform
                    </h1>
                    <p>
                      Scale your energy business on a single, integrated
                      platform designed to eliminate silos and accelerate every
                      workflow.
                    </p>

                    <ul>
                      <li>
                        <div class="icon">
                          <img
                            src="assets/image/sass/vector/banner-vector1.svg"
                            alt=""
                          />
                        </div>
                        <div class="content">
                          <h2>All-Inclusive Dashboard</h2>
                        </div>
                      </li>
                      <li>
                        <div class="icon">
                          <img
                            src="assets/image/sass/vector/banner-vector2.svg"
                            alt=""
                          />
                        </div>
                        <div class="content">
                          <h2>Post Audit Forms</h2>
                        </div>
                      </li>
                      <li>
                        <div class="icon">
                          <img
                            src="assets/image/sass/vector/banner-vector3.svg"
                            alt=""
                          />
                        </div>
                        <div class="content">
                          <h2>Installation Scheduling</h2>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="banner-img-area">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12 d-flex justify-content-center mb-120">
                      <div class="banner-img">
                        <img src="assets/crm-banner-2.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="home2-testimonial-section mb-120">
              <div className="container">
                <div className="testimonial-slider-area">
                  <div className="swiper home2-testimonial-slider">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div className="testimonial-card2">
                          <div className="row gy-4">
                            <div className="col-lg-4 col-md-7">
                              <div className="testimonial-img-wrap">
                                <div className="testimonial-img">
                                  <img src="assets/test.png" alt="" />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div className="testimonial-content-wrap">
                                <div className="testimonial-content">
                                  <p>
                                    Step into the future of business management
                                    with our interactive demo. Explore how
                                    Insight Wide seamlessly integrates lead
                                    tracking, automated workflows, and advanced
                                    analytics into one intuitive dashboard. See
                                    firsthand how our extensive functionality
                                    can help you scale your operations and build
                                    stronger client relationships with ease.
                                  </p>
                                </div>
                                <div className="author-area">
                                  <div className="button-area">
                                    <a
                                      className="primary-btn1"
                                      href="https://insightwide.com/dashboard"
                                      target="_blank"
                                    >
                                      <span style={{ color: "#fff" }}>
                                        View Live
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                          </g>
                                        </svg>
                                      </span>

                                      <span style={{ color: "#fff" }}>
                                        View Live
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                          </g>
                                        </svg>
                                      </span>
                                    </a>
                                  </div>
                                </div>

                                <svg
                                  className="joint1"
                                  width="24"
                                  height="30"
                                  viewBox="0 0 24 30"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M24 0C14.4 10.6667 4 4.44444 0 0V30C9.2 19.3333 19.8333 25.5556 24 30V0Z" />
                                </svg>
                                <svg
                                  className="joint2"
                                  width="24"
                                  height="30"
                                  viewBox="0 0 24 30"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M24 0C14.4 10.6667 4 4.44444 0 0V30C9.2 19.3333 19.8333 25.5556 24 30V0Z" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="slider-btn-area">
                    <div className="franctional-pagi"></div>
                    <div className="slider-btn-grp two"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="our-service-section style-2 mb-120">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 mb-70">
                    <div className="section-title three">
                      <div className="left-content">
                        <span>Solutions</span>
                        <h2 className="text-anim">
                          Solutions Designed for Innovation
                        </h2>
                      </div>
                      <div className="right-content">
                        <p className="text-anim">
                          Smart solutions for real-world problems
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row gx-xxl-4 gx-lg-3 g-4 gy-sm-5 gy-4">
                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".2"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
                            width="50px"
                            height="50px"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            {...props}
                          >
                            <g id="icomoon-ignore" />
                            <path
                              d="M26.663 11.193c0-5.888-4.773-10.662-10.663-10.662s-10.662 4.774-10.662 10.662c0 3.468 1.661 6.542 4.225 8.487l-0.005 0.003c0.049 0.033 0.099 0.071 0.152 0.112 0.005 0.004 0.010 0.008 0.015 0.011 0.825 0.651 2.011 2.173 2.011 4.181v7.482h8.53v-7.482c0-2.133 1.232-3.663 2.133-4.271l-0.003-0.003c2.589-1.944 4.268-5.033 4.268-8.52zM12.801 30.403v-3.217h6.398v3.217h-6.398zM16 12.259c-0.588 0-1.066-0.478-1.066-1.066s0.479-1.067 1.066-1.067 1.066 0.479 1.066 1.067c0 0.588-0.479 1.066-1.066 1.066zM21.755 18.861c-0.014 0.011-0.028 0.022-0.042 0.033-1.18 0.839-2.514 2.646-2.514 5.093v2.133h-2.666v-12.87c0.918-0.238 1.599-1.065 1.599-2.056 0-1.178-0.955-2.133-2.133-2.133s-2.133 0.955-2.133 2.133c0 0.992 0.681 1.819 1.599 2.056v12.87h-2.666v-2.133c0-2.296-1.302-4.138-2.407-5.010-0.008-0.007-0.019-0.015-0.029-0.023-0.035-0.027-0.069-0.053-0.102-0.078-0.018-0.016-0.036-0.031-0.056-0.045-2.417-1.834-3.804-4.618-3.804-7.638 0-5.291 4.305-9.596 9.596-9.596s9.596 4.305 9.596 9.596c-0 3.040-1.4 5.834-3.842 7.667z"
                              fill="#000000"
                            />
                          </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            Lighting
                          </a>
                        </h3>
                        <p>
                          Insight Wide software provides automated VEU and ESS
                          assistance for your business lighting rebates and
                          incentives right now today.
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".3"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
    fill="#000000"
    width="40px"
    height="40px"
    viewBox="0 0 24 24"
    id="coffee-machine"
    data-name="Line Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon line-color"
    {...props}
  >
    <path
      id="secondary"
      d="M18,15V13H14v2a2,2,0,0,0,2,2h0A2,2,0,0,0,18,15ZM16,7V9"
      style={{
        fill: "none",
        stroke: "rgb(44, 169, 188)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
      }}
    />
    <path
      id="primary"
      d="M20,21H4a1,1,0,0,1-1-1V17H21v3A1,1,0,0,1,20,21ZM19,3H4A1,1,0,0,0,3,4V17h7V7h8a1,1,0,0,0,1-1Z"
      style={{
        fill: "none",
        stroke: "rgb(0, 0, 0)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
      }}
    />
  </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            HVAC
                          </a>
                        </h3>
                        <p>
                          Our software delivers a thorough assessment of your
                          HVAC needs and provides accurate air conditioning
                          solutions for the same now.
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".4"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                         <svg
    height="50px"
    width="50px"
    id="_x32_"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">{"\n\t.st0{fill:#000000;}\n"}</style>
    <g>
      <path
        className="st0"
        d="M512,346.046l-1.425-19.564l-22.506-309.46h-16.96h-361.7H95.722L0,346.046h24.301h261.704l5.245,100.304 l-77.276,12.155v36.474h237.082v-36.474l-78.113-12.155l-22.498-100.304h141.943H512z M394.029,53.496h60.121l4.772,65.602h-66.087 L394.029,53.496z M392.341,146.453h68.572l5.102,70.162h-74.952L392.341,146.453z M123.096,53.496h59.141l-13.116,65.602h-65.108 L123.096,53.496z M131.025,309.572H48.598L67.68,243.97h76.462L131.025,309.572z M75.642,216.614l20.41-70.162h67.596 l-14.034,70.162H75.642z M246.574,309.572H158.92l13.117-65.602h81.697L246.574,309.572z M256.717,216.614h-79.208l14.033-70.162 h72.829L256.717,216.614z M197.01,119.097l13.121-65.602h64.382l-7.16,65.602H197.01z M362.017,309.572h-87.922l7.159-65.602 h81.955L362.017,309.572z M363.708,216.614h-79.47l7.653-70.162h73.092L363.708,216.614z M365.48,119.097h-70.606l7.159-65.602 h64.64L365.48,119.097z M389.372,309.572l1.192-65.602h77.441l4.768,65.602H389.372z"
      />
    </g>
  </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            Solar Installation
                          </a>
                        </h3>
                        <p>
                          Our software provides the right guidance for solar
                          installation to meet all your specific energy
                          requirements and personal power goals.
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".5"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={50}
                            height={50}
                            {...props}
                          >
                            <path d="M22.417 36.146c-.972 0-1.763-.789-1.763-1.761a1.764 1.764 0 0 1 3.526 0c0 .972-.79 1.761-1.763 1.761Zm0-2.04a.28.28 0 0 0-.279.279c0 .307.558.307.558 0a.279.279 0 0 0-.279-.278Zm6.627 2.04a1.763 1.763 0 1 1 .002-3.525 1.763 1.763 0 0 1-.002 3.525Zm0-2.04a.278.278 0 0 0-.278.279c0 .307.557.307.557 0a.278.278 0 0 0-.279-.278Zm5.55-14.88a1.715 1.715 0 0 0-1.369-.676H16.366l-.438-1.642a1.91 1.91 0 0 0-1.844-1.416h-1.106a.742.742 0 0 0 0 1.483h1.106c.192 0 .36.13.41.316l3.544 13.25a2.226 2.226 0 0 0 2.148 1.65H32.08a.743.743 0 0 0 0-1.485H20.186a.74.74 0 0 1-.715-.547l-.27-1.012h11.168a2.978 2.978 0 0 0 2.873-2.205l1.653-6.22a1.718 1.718 0 0 0-.3-1.497Zm-1.176.903a.24.24 0 0 1 .042.212l-.735 2.766h-2.606l.413-3.073h2.693c.105 0 .165.06.193.095Zm-4.796 2.978h-2.727v-3.073h3.141l-.414 3.073Zm-4.21-3.073v3.073h-2.724l-.417-3.073h3.14Zm-4.638 0 .416 3.073h-2.601l-.823-3.073h3.008Zm.617 4.557.416 3.072H18.81l-.823-3.072h2.405Zm1.498 0h2.523v3.072h-2.108l-.415-3.072Zm4.006 3.072v-3.072h2.527l-.414 3.072h-2.113Zm4.474 0h-.863l.413-3.072h2.412l-.523 1.968a1.49 1.49 0 0 1-1.438 1.104h-.001ZM14.566 7.408a.695.695 0 0 0-.695-.695H6.238a.695.695 0 1 0 0 1.39h7.633a.695.695 0 0 0 .695-.695Zm20.962 0a.742.742 0 1 1-1.484 0 .742.742 0 0 1 1.484 0Zm2.32-.742a.742.742 0 1 0 0 1.484.742.742 0 0 0 0-1.484Zm3.06 0a.742.742 0 1 0 0 1.484.742.742 0 0 0 0-1.484Zm6.548 32.422L45.18 37.17c.002-.045.01-.09.01-.137V8.047A4.055 4.055 0 0 0 41.142 4H6.047A4.055 4.055 0 0 0 2 8.047v28.986a4.055 4.055 0 0 0 4.047 4.047h31.148l.001 2.78c0 .598.336 1.127.878 1.38a1.52 1.52 0 0 0 1.622-.208l1.39-1.156.773 1.663a2.136 2.136 0 0 0 3.947-.167 2.118 2.118 0 0 0-.07-1.634l-.773-1.664 1.779-.318a1.513 1.513 0 0 0 1.204-1.108 1.51 1.51 0 0 0-.49-1.56ZM3.481 8.047a2.566 2.566 0 0 1 2.566-2.56h35.096a2.566 2.566 0 0 1 2.566 2.56v1.279H3.48v-1.28Zm33.712 25.666.002 5.88H6.047a2.566 2.566 0 0 1-2.566-2.559v-26.22h40.227V35.93l-4.01-3.38a1.51 1.51 0 0 0-1.624-.216 1.508 1.508 0 0 0-.88 1.38Zm9.286 6.583-2.725.486a.74.74 0 0 0-.542 1.044l1.179 2.54a.646.646 0 0 1 .022.497.662.662 0 0 1-.586.43.653.653 0 0 1-.623-.379l-1.179-2.536a.743.743 0 0 0-1.147-.258l-2.198 1.74.062-10.178 7.757 6.54-.02.074Z" />
                          </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            Hot Water System
                          </a>
                        </h3>
                        <p>
                          Insight Wide software ensures ease in managing your
                          hot water systems without much stress by automating
                          every single complex task
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".2"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={50}
                            height={50}
                            {...props}
                          >
                            <path d="M39.984 33.055a1.358 1.358 0 0 0 1.703-.867l1.243-3.813a.786.786 0 0 0-.5-.984l-1.727-.563c.07-.61.11-1.219.11-1.828 0-.61-.04-1.219-.11-1.828l1.18-.383c.343-.11.625-.352.789-.672.164-.32.195-.687.078-1.031l-1.063-3.266c-.226-.71-1-1.101-1.703-.867l-1.18.383a15.997 15.997 0 0 0-2.148-2.961l.735-1.008a1.358 1.358 0 0 0-.297-1.89l-2.782-2.024a1.358 1.358 0 0 0-1.89.297l-.735 1.008a15.336 15.336 0 0 0-3.476-1.133V8.383c0-.75-.61-1.352-1.352-1.352h-3.437c-.75 0-1.352.61-1.352 1.352v1.242c-1.195.234-2.36.617-3.476 1.133l-.735-1.008a1.357 1.357 0 0 0-1.89-.297l-2.782 2.024c-.296.21-.484.523-.539.882-.054.36.032.72.243 1.008l.726 1.008a15.745 15.745 0 0 0-2.148 2.96l-1.18-.382a1.344 1.344 0 0 0-1.703.867l-1.063 3.266a1.344 1.344 0 0 0 .867 1.703l1.18.383c-.07.61-.11 1.219-.11 1.828 0 .61.04 1.219.11 1.828l-1.726.563a.786.786 0 0 0-.5.984l1.242 3.813c.11.343.351.624.672.789.32.164.687.195 1.031.078l1.18-.383a15.745 15.745 0 0 0 2.148 2.96l-.726 1.009a1.363 1.363 0 0 0-.243 1.007c.055.36.25.672.54.883l2.78 2.024a1.358 1.358 0 0 0 1.891-.297l.735-1.008c1.117.516 2.28.898 3.476 1.133v1.242c0 .75.61 1.352 1.352 1.352h3.437c.75 0 1.352-.61 1.352-1.352v-1.242a15.338 15.338 0 0 0 3.476-1.133l.727 1.008a1.35 1.35 0 0 0 1.89.297l2.782-2.024a1.35 1.35 0 0 0 .297-1.89l-.727-1.008a15.74 15.74 0 0 0 2.149-2.961l1.18.383Zm-2.468-1.282a14.315 14.315 0 0 1-2.11 2.907 1.359 1.359 0 0 0-.117 1.726l.71.977-2.444 1.773-.711-.976a1.358 1.358 0 0 0-1.68-.422 13.91 13.91 0 0 1-3.406 1.11c-.64.116-1.11.679-1.11 1.327v1.203h-3.023v-1.203c0-.648-.469-1.21-1.11-1.328a14.077 14.077 0 0 1-3.413-1.11 1.358 1.358 0 0 0-1.68.423l-.711.976-2.445-1.773.71-.977a1.35 1.35 0 0 0-.117-1.726 14.315 14.315 0 0 1-2.11-2.907 1.353 1.353 0 0 0-1.6-.64L10 31.508l-.93-2.875 1.149-.375a1.355 1.355 0 0 0 .922-1.469 13.867 13.867 0 0 1 0-3.594 1.36 1.36 0 0 0-.922-1.468l-1.149-.375.93-2.875 1.148.375a1.363 1.363 0 0 0 1.61-.641 14.31 14.31 0 0 1 2.11-2.906 1.35 1.35 0 0 0 .116-1.727l-.71-.976 2.445-1.774.71.977a1.358 1.358 0 0 0 1.68.422 13.902 13.902 0 0 1 3.407-1.11c.64-.117 1.109-.68 1.109-1.328V8.586h3.023v1.203c0 .649.47 1.211 1.11 1.328 1.172.219 2.32.594 3.414 1.11a1.358 1.358 0 0 0 1.68-.422l.71-.977 2.446 1.774-.711.976a1.35 1.35 0 0 0 .117 1.727 14.31 14.31 0 0 1 2.11 2.906c.312.57.992.844 1.6.64l1.15-.374.937 2.875-1.149.375a1.355 1.355 0 0 0-.921 1.468 13.883 13.883 0 0 1 0 3.594 1.36 1.36 0 0 0 .921 1.469l1.149.375-.938 2.875-1.148-.375a1.349 1.349 0 0 0-1.602.64h-.007Z" />
                            <path d="M25 13.281c-6.46 0-11.719 5.258-11.719 11.719 0 6.46 5.258 11.719 11.719 11.719 6.46 0 11.719-5.258 11.719-11.719 0-6.46-5.258-11.719-11.719-11.719Zm0 21.875c-5.602 0-10.156-4.554-10.156-10.156S19.398 14.844 25 14.844 35.156 19.398 35.156 25 30.602 35.156 25 35.156Z" />
                            <path d="M26.797 23.047h1.172v3.906h-1.172v1.563h3.906v-1.563h-1.172v-3.906h1.172v-1.563h-3.906v1.563ZM23.047 21.484h-1.563a.793.793 0 0 0-.765.61l-1.43 6.422h1.602l.343-1.563h2.047l.344 1.563h1.602l-1.43-6.422a.779.779 0 0 0-.766-.61h.016Zm-1.453 3.907.523-2.344h.313l.523 2.344h-1.359ZM36.367 44.602c-8.625 5.008-19.508 3.735-26.782-3.023l1.493.21.218-1.546-3.867-.555a.775.775 0 0 0-.883.883l.555 3.867 1.547-.218-.227-1.578a24.238 24.238 0 0 0 16.602 6.57c4.164 0 8.351-1.07 12.133-3.266l-.782-1.351-.007.007ZM46.078 13.055l-1.36.773c4.868 8.586 3.547 19.383-3.132 26.586l.21-1.492-1.546-.219-.555 3.867a.773.773 0 0 0 .773.89h.11l3.867-.554-.218-1.547-1.602.227c7.234-7.695 8.68-19.305 3.453-28.523v-.008ZM13.055 3.92l.773 1.36C22.414.413 33.211 1.733 40.414 8.42l-1.492-.21-.219 1.547 3.867.555h.11a.775.775 0 0 0 .773-.89l-.555-3.868-1.546.218.226 1.602C33.891.14 22.273-1.306 13.055 3.921ZM8.203 11.078l1.547.218.555-3.867a.799.799 0 0 0-.22-.664.767.767 0 0 0-.663-.219l-3.867.555.218 1.547 1.602-.227C.141 16.11-1.305 27.726 3.922 36.945l1.36-.774C.413 27.586 1.733 16.79 8.421 9.585l-.211 1.493h-.008Z" />
                          </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            ERP Softwares
                          </a>
                        </h3>
                        <p>
                          Our ERP software streamlines processes, integrates
                          operations, and boosts efficiency—helping
                          organizations manage.
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".3"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M27.7992 31.2999V4.7C27.7992 4.31343 27.4857 4 27.0991 4H7.49902V5.4H26.3991V31.2999H27.7992Z" />
                            <path d="M29.9002 36.1999C29.5136 36.1999 29.2002 36.5134 29.2002 36.8999V45.2999C29.2002 45.6865 29.5136 45.9999 29.9002 45.9999H45.3003C45.6869 45.9999 46.0003 45.6865 46.0003 45.2999V36.8999C46.0003 36.5134 45.6869 36.1999 45.3003 36.1999H38.3003V34.7999H39.0003C39.3868 34.7999 39.7003 34.4865 39.7003 34.0999V29.9974L45.9743 7.68969C45.9743 7.68183 45.9743 7.67499 45.9743 7.66713C45.9969 7.57758 46.001 7.48427 45.9863 7.39301C45.9863 7.37455 45.9788 7.35781 45.9743 7.33969C45.9548 7.24604 45.9159 7.15785 45.8602 7.07992L43.7601 4.27993C43.6282 4.10391 43.4207 4 43.2003 4H32.0002C31.7798 4 31.5723 4.10391 31.4403 4.27993L29.3403 7.07992C29.2843 7.15751 29.2453 7.24604 29.2255 7.33969C29.221 7.35781 29.2163 7.37455 29.2135 7.39301C29.1988 7.48427 29.2029 7.57758 29.2255 7.66713V7.68969L35.5002 29.9974V34.0999C35.5002 34.4865 35.8137 34.7999 36.2002 34.7999H36.9002V36.1999H29.9002ZM38.3003 33.3999H36.9002V30.5999H38.3003V33.3999ZM37.6002 22.284L33.6248 8.19999H41.5757L37.6002 22.284ZM39.0044 27.2989L38.3269 24.8598L43.0301 8.19999H44.3764L39.0044 27.2989ZM32.3502 5.4H42.8503L43.9003 6.79999H31.3002L32.3502 5.4ZM32.1704 8.19999L36.9255 25.0461L38.0791 29.1999H36.7307L30.8241 8.19999H32.1704ZM44.6003 44.5999H30.6002V37.5999H44.6003V44.5999Z" />
                            <path d="M32.3882 42.4298L33.7883 43.1298C33.9851 43.2282 34.2169 43.2282 34.4137 43.1298L35.8138 42.4298C36.0523 42.3108 36.2024 42.0664 36.201 41.7998V40.3999C36.2024 40.1332 36.0523 39.8889 35.8138 39.7699L34.4137 39.0699C34.2169 38.9715 33.9851 38.9715 33.7883 39.0699L32.3882 39.7699C32.1497 39.8889 31.9996 40.1332 32.001 40.3999V41.7998C31.9996 42.0664 32.1497 42.3108 32.3882 42.4298ZM33.401 40.8326L34.101 40.4826L34.801 40.8326V41.3671L34.101 41.7171L33.401 41.3671V40.8326Z" />
                            <path d="M37.6016 39H43.2016V40.4H37.6016V39Z" />
                            <path d="M37.6016 41.8008H43.2016V43.2008H37.6016V41.8008Z" />
                            <path d="M4.7 34.8007H24.3001C24.6867 34.8007 25.0001 34.4873 25.0001 34.1007V13.8008C25.0001 13.7861 24.9923 13.7727 24.9916 13.758C24.9878 13.6962 24.9755 13.635 24.9554 13.5762C24.9475 13.5536 24.942 13.5328 24.9321 13.5109C24.8983 13.4347 24.8508 13.3653 24.7923 13.3058L18.4923 7.00586C18.4331 6.94707 18.3638 6.89956 18.2879 6.86572C18.2653 6.85547 18.2438 6.84966 18.2178 6.84145C18.16 6.82163 18.1002 6.81001 18.0394 6.80625C18.0295 6.80864 18.0155 6.80078 18.0001 6.80078H4.7C4.31343 6.80078 4 7.11421 4 7.50078V34.1007C4 34.4873 4.31343 34.8007 4.7 34.8007ZM22.6103 13.1008H18.7001V9.19062L22.6103 13.1008ZM5.40001 8.20078H17.3001V13.8008C17.3001 14.1873 17.6135 14.5008 18.0001 14.5008H23.6001V33.4007H5.40001V8.20078Z" />
                            <path d="M7.27867 13.7641L9.37868 14.4641C9.52223 14.5116 9.67741 14.5116 9.82097 14.4641L11.921 13.7641C12.2071 13.6688 12.3998 13.4012 12.3998 13.0997V10.9997C12.3998 10.6982 12.2071 10.4306 11.921 10.3352L9.82097 9.63524C9.67741 9.58773 9.52223 9.58773 9.37868 9.63524L7.27867 10.3352C6.99258 10.4306 6.7998 10.6982 6.7998 10.9997V13.0997C6.7998 13.4012 6.99258 13.6688 7.27867 13.7641ZM9.59982 11.0376L10.9998 11.5045V12.5949L9.59982 13.0617L8.19981 12.5949V11.5045L9.59982 11.0376Z" />
                            <path d="M13.7998 9.59961H15.8998V10.9996H13.7998V9.59961Z" />
                            <path d="M13.7998 12.4004H15.8998V13.8004H13.7998V12.4004Z" />
                            <path d="M4.7 45.9992H21.5001C21.8867 45.9992 22.2001 45.6858 22.2001 45.2992V36.8992C22.1964 36.8715 22.1905 36.8442 22.1834 36.8172C22.1793 36.7779 22.1717 36.7389 22.1601 36.701C22.1236 36.6237 22.0873 36.5465 22.0518 36.4686C22.0439 36.4583 22.0306 36.4549 22.0224 36.445C21.9752 36.3927 21.9202 36.3479 21.8593 36.3127C21.8368 36.2956 21.8135 36.2802 21.7893 36.2666C21.699 36.2231 21.6003 36.2002 21.5001 36.1992H4.7C4.59917 36.2009 4.50005 36.2249 4.40948 36.2693C4.38521 36.2833 4.36197 36.2987 4.33941 36.3154C4.27891 36.351 4.22422 36.3958 4.17705 36.4477C4.16885 36.4576 4.15552 36.461 4.14766 36.4716C4.14014 36.4819 4.13091 36.515 4.11758 36.5352C4.08408 36.5875 4.05742 36.6442 4.03931 36.7041C4.02769 36.7416 4.02017 36.7806 4.01606 36.8203C4.00923 36.8462 4.00376 36.8726 4 36.8992V45.2992C4 45.6858 4.31343 45.9992 4.7 45.9992ZM5.40001 44.5992V40.2122C5.63653 40.3346 5.89869 40.3985 6.16495 40.3992H20.0352C20.3014 40.3985 20.5636 40.3346 20.8001 40.2122V44.5992H5.40001ZM20.6036 37.5992L20.3059 38.7893C20.2741 38.9127 20.1626 38.9992 20.0352 38.9992H6.16495C6.03712 38.9996 5.92535 38.9131 5.89357 38.7893L5.59654 37.5992H20.6036Z" />
                            <path d="M6.7998 41.8008H8.19981V43.2008H6.7998V41.8008Z" />
                            <path d="M9.59961 41.8008H13.7996V43.2008H9.59961V41.8008Z" />
                            <path d="M6.7998 30.5996V31.9996H22.1999V30.5996H6.7998Z" />
                          </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            Finance
                          </a>
                        </h3>
                        <p>
                          We provide finance software solutions to manage
                          accounts, track transactions, and optimize financial
                          operations—helping businesses make smarter decisions.
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".4"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M32.8127 14.9617C32.7869 14.9773 32.7572 14.9813 32.7314 15L31.1713 16.1719C30.8268 16.4313 30.7572 16.9211 31.0158 17.2656C31.1689 17.4703 31.4041 17.5773 31.6416 17.5773C31.8049 17.5773 31.9697 17.5266 32.1104 17.4211L32.1643 17.3805C31.4025 19.9742 29.0057 21.875 26.1697 21.875C24.2752 21.875 22.5049 21.0289 21.3104 19.5539C21.0393 19.2187 20.5463 19.1672 20.2119 19.4383C19.876 19.7102 19.8244 20.2023 20.0963 20.5367C21.5885 22.3797 23.8018 23.4375 26.1697 23.4375C29.7893 23.4375 32.833 20.9586 33.7158 17.6125L33.7502 17.6586C33.9033 17.8633 34.1385 17.9703 34.376 17.9703C34.5393 17.9703 34.7041 17.9195 34.8447 17.8141C35.1893 17.5547 35.2588 17.0648 35.0002 16.7203L33.826 15.1562C33.8143 15.1406 33.7979 15.1344 33.7854 15.1203C33.7494 15.0789 33.7088 15.0461 33.6658 15.0133C33.6268 14.9844 33.59 14.9555 33.5479 14.9336C33.5041 14.9117 33.4572 14.8992 33.4088 14.8852C33.358 14.8703 33.3088 14.8578 33.2564 14.8539C33.2369 14.8539 33.2197 14.8438 33.201 14.8438C33.1682 14.8438 33.1408 14.8586 33.1096 14.8617C33.058 14.868 33.008 14.8758 32.958 14.8922C32.9057 14.9102 32.8604 14.9344 32.8127 14.9617Z" />
                            <path d="M47.2623 21.0922C47.2623 17.0367 44.1537 13.6945 40.1936 13.3188C39.8029 5.91094 33.6725 0 26.1693 0C20.3553 0 15.3529 3.54766 13.2154 8.59219H12.8936C7.29355 8.59219 2.7373 13.1492 2.7373 18.75C2.7373 22.9656 5.31934 26.5867 8.98418 28.1211V30.5164C5.90684 30.9031 3.51543 33.5312 3.51465 36.7125C3.51543 40.1586 6.32012 42.9625 9.76543 42.9625C13.2115 42.9625 16.0146 40.1586 16.0146 36.7125C16.0146 33.5312 13.624 30.9031 10.5467 30.5164V28.6211C11.3014 28.8008 12.085 28.9062 12.8936 28.9062H23.8287V34.4148C19.8865 34.8086 16.7975 38.1437 16.7975 42.1875C16.7975 46.4953 20.3021 50 24.61 50C28.9178 50 32.4225 46.4953 32.4225 42.1875C32.4225 38.1437 29.3334 34.8086 25.3912 34.4148V28.9062H38.6686V30.5172C35.5912 30.9039 33.1998 33.532 33.199 36.7133C33.1998 40.1594 36.0045 42.9633 39.4498 42.9633C42.8959 42.9633 45.699 40.1594 45.699 36.7133C45.699 33.532 43.3084 30.9039 40.2311 30.5172V28.8672C44.1732 28.4734 47.2623 25.1375 47.2623 21.0922ZM14.4521 36.7125C14.4521 39.2977 12.3498 41.4 9.76543 41.4C7.18027 41.4 5.07793 39.2977 5.07715 36.7125C5.07793 34.1273 7.18027 32.025 9.76543 32.025C12.3498 32.025 14.4521 34.1281 14.4521 36.7125ZM30.86 42.1875C30.86 45.6336 28.0561 48.4375 24.61 48.4375C21.1639 48.4375 18.36 45.6336 18.36 42.1875C18.36 38.7414 21.1639 35.9375 24.61 35.9375C28.0561 35.9375 30.86 38.7414 30.86 42.1875ZM4.2998 18.75C4.2998 14.0867 8.03418 10.2867 12.6686 10.1664C12.3107 11.4055 12.1076 12.7102 12.1076 14.0625C12.1076 14.4945 12.4568 14.8438 12.8889 14.8438C13.3209 14.8438 13.6701 14.4945 13.6701 14.0625C13.6701 7.17031 19.2772 1.5625 26.1693 1.5625C33.0615 1.5625 38.6686 7.17031 38.6686 14.0625C38.6686 14.4945 39.0178 14.8438 39.4498 14.8438H39.4506C42.8967 14.8438 45.6998 17.6469 45.6998 21.0922C45.6998 24.5391 42.8967 27.3438 39.4506 27.3438H12.8936C8.15449 27.3438 4.2998 23.4883 4.2998 18.75ZM44.1365 36.7125C44.1365 39.2977 42.0342 41.4 39.4498 41.4C36.8646 41.4 34.7623 39.2977 34.7615 36.7125C34.7623 34.1273 36.8646 32.025 39.4498 32.025C42.0342 32.025 44.1365 34.1281 44.1365 36.7125Z" />
                            <path d="M26.4 44.2992C26.5523 44.4515 26.7523 44.5281 26.9523 44.5281C27.1523 44.5281 27.3523 44.4515 27.5047 44.2992L29.0617 42.7429C29.0633 42.7414 29.0648 42.7414 29.0664 42.7398C29.2188 42.5875 29.2953 42.3867 29.2953 42.1867C29.2953 41.9867 29.2188 41.7859 29.0664 41.6335C29.0648 41.632 29.0633 41.632 29.0617 41.6304L27.5047 40.0726C27.1992 39.7671 26.7055 39.7671 26.4 40.0726C26.0945 40.3781 26.0945 40.8718 26.4 41.1773L27.4086 42.1867L26.4 43.1945C26.0945 43.5 26.0945 43.9945 26.4 44.2992Z" />
                            <path d="M22.8182 40.0729C22.5127 39.7674 22.019 39.7674 21.7135 40.0729L20.1604 41.6275C20.1572 41.6307 20.1533 41.6307 20.151 41.6338C19.9979 41.7869 19.9221 41.9869 19.9229 42.1877C19.9221 42.3885 19.9979 42.5893 20.151 42.7416C20.1533 42.7447 20.1572 42.7447 20.1604 42.7479L21.7135 44.301C21.8658 44.4533 22.0658 44.5299 22.2658 44.5299C22.4658 44.5299 22.6658 44.4533 22.8182 44.301C23.1236 43.9955 23.1236 43.5018 22.8182 43.1963L21.8096 42.1877L22.8182 41.1775C23.1236 40.8721 23.1236 40.3775 22.8182 40.0729Z" />
                            <path d="M23.6394 46.0728C23.7027 46.0892 23.7667 46.0962 23.8292 46.0962C24.1792 46.0962 24.4972 45.8595 24.5863 45.504L26.148 39.2525C26.2535 38.8345 25.9988 38.4103 25.5792 38.3056C25.1589 38.1986 24.7363 38.4548 24.6324 38.8743L23.0706 45.1259C22.9652 45.5439 23.2206 45.9681 23.6394 46.0728Z" />
                            <path d="M41.2373 38.0518C41.3896 38.2041 41.5896 38.2807 41.7896 38.2807C41.9896 38.2807 42.1896 38.2041 42.342 38.0518L43.1193 37.2752C43.1209 37.2736 43.1225 37.2736 43.124 37.2721C43.2764 37.1197 43.3529 36.9189 43.3529 36.7189C43.3529 36.5189 43.2764 36.3182 43.124 36.1658C43.1225 36.1643 43.1209 36.1643 43.1193 36.1627L42.3459 35.3893C42.0404 35.0838 41.5467 35.0838 41.2412 35.3893C40.9357 35.6947 40.9357 36.1885 41.2412 36.4939L41.4662 36.7189L41.2373 36.9471C40.9326 37.2518 40.9326 37.7463 41.2373 38.0518Z" />
                            <path d="M37.6596 35.3873C37.3541 35.0818 36.8604 35.0818 36.5549 35.3873L35.7775 36.1639C35.776 36.1654 35.7744 36.1654 35.7729 36.167C35.6205 36.3193 35.5439 36.5201 35.5439 36.7201C35.5439 36.9201 35.6205 37.1209 35.7729 37.2732C35.7744 37.2748 35.776 37.2748 35.7775 37.2764L36.5549 38.0529C36.7072 38.2053 36.9072 38.2818 37.1072 38.2818C37.3072 38.2818 37.5072 38.2053 37.6596 38.0529C37.965 37.7475 37.965 37.2529 37.6596 36.9482L37.4314 36.7201L37.6596 36.492C37.965 36.1873 37.965 35.6928 37.6596 35.3873Z" />
                            <path d="M39.0803 34.9633L38.3006 38.0867C38.1967 38.5055 38.4506 38.9297 38.8701 39.0344C38.9334 39.05 38.9975 39.057 39.06 39.057C39.41 39.057 39.7279 38.8195 39.8178 38.4648L40.5975 35.3414C40.7014 34.9227 40.4475 34.4984 40.0279 34.3938C39.6076 34.2914 39.185 34.5453 39.0803 34.9633Z" />
                            <path d="M11.5533 38.0518C11.7057 38.2041 11.9057 38.2807 12.1057 38.2807C12.3057 38.2807 12.5057 38.2041 12.658 38.0518L13.4354 37.2752C13.4369 37.2736 13.4385 37.2736 13.44 37.2721C13.5924 37.1197 13.6689 36.9189 13.6689 36.7189C13.6689 36.5189 13.5924 36.3182 13.44 36.1658C13.4385 36.1643 13.4369 36.1643 13.4354 36.1627L12.6619 35.3893C12.3564 35.0838 11.8627 35.0838 11.5572 35.3893C11.2518 35.6947 11.2518 36.1885 11.5572 36.4939L11.7822 36.7189L11.5533 36.9471C11.2479 37.2518 11.2479 37.7463 11.5533 38.0518Z" />
                            <path d="M7.97598 35.3873C7.67051 35.0818 7.17676 35.0818 6.87129 35.3873L6.09395 36.1639C6.09238 36.1654 6.09082 36.1654 6.08926 36.167C5.93691 36.3193 5.86035 36.5201 5.86035 36.7201C5.86035 36.9201 5.93691 37.1209 6.08926 37.2732C6.09082 37.2748 6.09238 37.2748 6.09395 37.2764L6.87129 38.0529C7.02363 38.2053 7.22363 38.2818 7.42363 38.2818C7.62363 38.2818 7.82363 38.2053 7.97598 38.0529C8.28145 37.7475 8.28145 37.2529 7.97598 36.9482L7.74785 36.7201L7.97598 36.492C8.28145 36.1873 8.28145 35.6928 7.97598 35.3873Z" />
                            <path d="M9.39572 34.9633L8.61603 38.0867C8.51212 38.5055 8.76603 38.9297 9.18556 39.0344C9.24884 39.05 9.3129 39.057 9.3754 39.057C9.7254 39.057 10.0434 38.8195 10.1332 38.4648L10.9129 35.3414C11.0168 34.9227 10.7629 34.4984 10.3434 34.3938C9.9254 34.2914 9.5004 34.5453 9.39572 34.9633Z" />
                            <path d="M18.5135 16.0969L18.5151 16.0977V16.0984C18.5252 16.1117 18.5401 16.1156 18.551 16.1281C18.6041 16.1914 18.6682 16.2406 18.7393 16.2836C18.7596 16.2969 18.7744 16.3195 18.7955 16.3305C18.8018 16.3336 18.8088 16.332 18.8143 16.3352C18.9135 16.3813 19.0221 16.4102 19.1385 16.4102H19.1393C19.2205 16.4102 19.3026 16.3969 19.3823 16.3711C19.3901 16.3687 19.3955 16.3633 19.4018 16.3609C19.4065 16.3594 19.4104 16.3555 19.4151 16.3539C19.4463 16.3422 19.4721 16.325 19.501 16.3094C19.5362 16.2906 19.5744 16.2789 19.6073 16.2539L19.6088 16.2523L21.169 15.0773C21.5135 14.818 21.5823 14.3281 21.3229 13.9836C21.0643 13.6406 20.576 13.5703 20.2291 13.8297L20.1768 13.8695C20.9393 11.2781 23.3354 9.37891 26.1705 9.37891C28.0651 9.37891 29.8354 10.225 31.0299 11.7C31.301 12.0352 31.7932 12.0867 32.1284 11.8156C32.4643 11.5437 32.5159 11.0516 32.244 10.7172C30.7518 8.87422 28.5385 7.81641 26.1705 7.81641C22.5518 7.81641 19.5088 10.293 18.6252 13.6375L18.594 13.5961C18.3362 13.2523 17.8455 13.1797 17.5002 13.4391C17.1557 13.6977 17.0846 14.1875 17.3432 14.5328L18.5135 16.0969Z" />
                          </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            Business operations
                          </a>
                        </h3>
                        <p>
                          Our business software streamlines workflows, improves
                          efficiency, and enhances productivity—helping
                          organizations run smoothly
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".5"
                  >
                    <div className="service-card style-2">
                      <div className="service-card-content">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={50}
                            height={50}
                            {...props}
                          >
                            <path d="M24.62 36.932c-4.64 0-8.414 3.774-8.414 8.414 0 .91.497 2.18 2.868 3.052 1.475.543 3.444.842 5.546.842 4.188 0 8.414-1.204 8.414-3.894 0-4.64-3.774-8.414-8.414-8.414Zm0 10.912c-3.936 0-7.019-1.097-7.019-2.498 0-3.87 3.149-7.018 7.02-7.018a7.026 7.026 0 0 1 7.018 7.018c0 1.401-3.083 2.498-7.019 2.498Zm0-11.572a4.269 4.269 0 0 0 4.264-4.264 4.269 4.269 0 0 0-4.264-4.264 4.269 4.269 0 0 0-4.264 4.264 4.269 4.269 0 0 0 4.264 4.264Zm0-7.132a2.872 2.872 0 0 1 2.869 2.868 2.872 2.872 0 0 1-2.869 2.869 2.872 2.872 0 0 1-2.869-2.869 2.872 2.872 0 0 1 2.87-2.868ZM9.164 20.946c.12 0 .24-.03.348-.093l8.466-4.888a.698.698 0 0 0 .349-.604V5.585c0-.249-.133-.48-.349-.604L9.512.093a.698.698 0 0 0-.697 0L.349 4.981A.698.698 0 0 0 0 5.585v9.776c0 .25.133.48.349.604l8.466 4.888a.697.697 0 0 0 .349.093Zm3.753-11.834.96-.554v2.462l-.96.554V9.112Zm-.698-1.209-7.07-4.082.959-.554 7.07 4.082-.96.554Zm-1.396.806-1.66.958-7.07-4.082 1.66-.958 7.07 4.082ZM9.861 19.04v-8.164l1.66-.958v2.864a.698.698 0 0 0 1.047.604l2.355-1.36a.698.698 0 0 0 .348-.604v-3.67l1.66-.958v8.164l-7.07 4.082ZM9.164 1.503l7.07 4.082-1.66.959-7.07-4.082 1.66-.959ZM1.395 6.794l7.07 4.082v8.164l-7.07-4.082V6.794Zm46.591.27c-.49 0-.896-.272-1.085-.727a1.143 1.143 0 0 1 .254-1.281 1.256 1.256 0 0 0 0-1.773l-1.198-1.198a1.246 1.246 0 0 0-.886-.367c-.335 0-.65.13-.887.367a1.143 1.143 0 0 1-1.281.254 1.143 1.143 0 0 1-.726-1.085C42.177.562 41.614 0 40.923 0H39.23c-.692 0-1.254.562-1.254 1.254 0 .49-.272.896-.727 1.085a1.143 1.143 0 0 1-1.28-.254 1.255 1.255 0 0 0-1.774 0l-1.197 1.198a1.255 1.255 0 0 0 0 1.773c.347.347.442.826.253 1.28a1.143 1.143 0 0 1-1.085.727c-.691 0-1.254.563-1.254 1.254v1.693c0 .692.563 1.254 1.254 1.254.491 0 .897.272 1.085.727.189.454.094.933-.253 1.28a1.246 1.246 0 0 0-.368.887c0 .335.13.65.368.887l1.197 1.197a1.256 1.256 0 0 0 1.773 0 1.144 1.144 0 0 1 1.282-.255c.454.189.726.595.726 1.087 0 .691.562 1.253 1.254 1.253h1.693c.691 0 1.254-.562 1.254-1.253 0-.491.271-.897.726-1.086a1.143 1.143 0 0 1 1.281.254c.237.237.552.367.887.367.335 0 .65-.13.886-.367l1.198-1.197c.236-.237.367-.552.367-.887 0-.335-.13-.65-.367-.887a1.143 1.143 0 0 1-.254-1.28 1.143 1.143 0 0 1 1.085-.727c.692 0 1.254-.563 1.254-1.254V8.317c0-.691-.563-1.254-1.254-1.254Zm-.142 2.808a2.527 2.527 0 0 0-2.232 1.585 2.528 2.528 0 0 0 .458 2.699l-1.002 1.002a2.527 2.527 0 0 0-2.699-.459 2.527 2.527 0 0 0-1.584 2.233h-1.417a2.528 2.528 0 0 0-1.584-2.234 2.528 2.528 0 0 0-2.7.46l-1.002-1.002a2.528 2.528 0 0 0 .459-2.7 2.528 2.528 0 0 0-2.233-1.584V8.455a2.527 2.527 0 0 0 2.233-1.584 2.528 2.528 0 0 0-.459-2.7l1.002-1.001a2.528 2.528 0 0 0 2.7.458 2.528 2.528 0 0 0 1.584-2.232h1.417a2.527 2.527 0 0 0 1.584 2.232c.936.388 1.957.21 2.7-.458l1.001 1.002a2.528 2.528 0 0 0-.458 2.699 2.527 2.527 0 0 0 2.232 1.584v1.417ZM40.076 4.33a4.84 4.84 0 0 0-4.835 4.835 4.84 4.84 0 0 0 4.835 4.835 4.84 4.84 0 0 0 4.835-4.835 4.84 4.84 0 0 0-4.835-4.835Zm0 8.274a3.443 3.443 0 0 1-3.44-3.44 3.443 3.443 0 0 1 3.44-3.439 3.443 3.443 0 0 1 3.44 3.44 3.443 3.443 0 0 1-3.44 3.44ZM20.63 10.498c0-.385.313-.698.698-.698h4.901l-.432-.432a.698.698 0 0 1 .987-.987l1.623 1.623a.698.698 0 0 1 0 .987l-1.623 1.623a.696.696 0 0 1-.987 0 .698.698 0 0 1 0-.986l.432-.432h-4.9a.698.698 0 0 1-.699-.698Zm20.145 12.558V39.1a.698.698 0 0 1-.698.698h-3.742l.432.432a.698.698 0 1 1-.987.986l-1.623-1.623a.698.698 0 0 1 0-.986l1.623-1.624a.698.698 0 0 1 .986.987l-.431.432h3.044V23.056a.698.698 0 0 1 1.396 0Zm-25.69 15.55a.698.698 0 0 1 0 .986l-1.623 1.623a.696.696 0 0 1-.987 0 .698.698 0 0 1 0-.986l.432-.432H9.164a.698.698 0 0 1-.698-.698V23.056a.698.698 0 0 1 1.395 0v15.345h3.045l-.432-.432a.698.698 0 1 1 .987-.987l1.623 1.623Z" />
                          </svg>
                        </div>
                        <h3>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                          >
                            Other Industries
                          </a>
                        </h3>
                        <p>
                          We deliver tailored software for various industries,
                          improving efficiency, streamlining processes, and
                          achieving unique goals
                        </p>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="view-details-btn"
                        >
                          Get A Demo
                          <svg
                            className="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <svg
                className="vector"
                width="103"
                height="251"
                viewBox="0 0 103 251"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M-23.3143 2.99772e-08C-6.83344 7.50379e-07 9.48606 3.24616 24.7124 9.55312C39.9388 15.8601 53.7738 25.1043 65.4275 36.7581C77.0812 48.4118 86.3255 62.2468 92.6324 77.4732C98.9394 92.6995 102.186 109.019 102.186 125.5C102.186 141.981 98.9394 158.3 92.6324 173.527C86.3255 188.753 77.0812 202.588 65.4275 214.242C53.7737 225.895 39.9387 235.14 24.7124 241.447C9.48604 247.754 -6.83347 251 -23.3143 251L-23.3143 227.16C-9.96408 227.16 3.25546 224.531 15.5895 219.422C27.9235 214.313 39.1305 206.825 48.5706 197.385C58.0106 187.945 65.4989 176.738 70.6078 164.404C75.7167 152.07 78.3463 138.85 78.3463 125.5C78.3463 112.15 75.7167 98.9301 70.6078 86.5961C65.4989 74.262 58.0106 63.055 48.5706 53.615C39.1305 44.1749 27.9235 36.6867 15.5895 31.5777C3.25547 26.4688 -9.96406 23.8393 -23.3143 23.8393L-23.3143 2.99772e-08Z" />
                </g>
              </svg>
            </div>

            <div class="home4-about-us-section mb-120 ">
              <div class="container">
                <div class="row gy-5">
                  <div class="col-lg-6 order-lg-1 order-2">
                    <div class="about-us-left-area">
                      <div class="img-area">
                        <div class="left-icon">
                          <svg
                            class="rotating-icon"
                            width="98"
                            height="99"
                            viewBox="0 0 98 99"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M48.9999 0H55.3925L52.1962 24.5284L48.9999 49.0607L45.8037 24.5284L42.6074 0H48.9999Z" />
                              <path d="M48.9999 98.0419H42.6074L45.8037 73.5096L48.9999 48.9772L52.1962 73.5096L55.3925 98.0419H48.9999Z" />
                              <path d="M98.0002 49.021V55.4162L73.4781 52.2186L48.9561 49.021L73.4781 45.8234L98.0002 42.6218V49.021Z" />
                              <path d="M0 49.021V42.6217L24.5221 45.8233L49.0401 49.021L24.5221 52.2186L0 55.4162V49.021Z" />
                              <path d="M83.6503 14.3558L88.1688 18.8801L68.5702 33.9666L48.9717 49.049L64.0478 29.4422L79.1279 9.83142L83.6503 14.3558Z" />
                              <path d="M14.3485 83.6825L9.83008 79.1621L29.4287 64.0757L49.0272 48.9893L33.9511 68.6L18.871 88.2069L14.3485 83.6825Z" />
                              <path d="M83.6503 83.6825L79.1279 88.2069L64.0478 68.6L48.9717 48.9893L68.5702 64.0757L88.1688 79.1621L83.6503 83.6825Z" />
                              <path d="M14.3485 14.3558L18.871 9.83142L33.9511 29.4422L49.0272 49.049L29.4287 33.9666L9.83008 18.8801L14.3485 14.3558Z" />
                            </g>
                          </svg>
                        </div>
                        <div class="right-img">
                          <img src="assets/new-2.png" alt="" />
                        </div>
                      </div>
                      <div class="feature-wrap">
                        <div class="title-area">
                          <h3>Before:</h3>
                        </div>
                        <div class="throwable-box-wrap">
                          <div
                            class="throwable-item-wrap"
                            data-eg-throwable-scene="true"
                          >
                            <p data-eg-throwable-el>
                              <span class="throwable-item">Google Sheets</span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="terracotta throwable-item">
                                Emails
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="periwinkle throwable-item">
                                WhatsApp
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="muted-green throwable-item">
                                Missed Reminders
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="aqua-green throwable-item">
                                Phone Notes
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="red throwable-item">
                                Paper Documents
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="green throwable-item">
                                Spreadsheets
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="green throwable-item">
                                Manual Follow-ups
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 order-lg-2 order-1">
                    <div class="about-us-right-area">
                      <div class="section-title">
                        <span>Goodbye to manual work</span>
                        <h2 class="text-anim">After</h2>

                        <div class="">
                          <img
                            src="assets/new.png"
                            alt=""
                            style={{ borderRadius: "10px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home4-portfolio-section style-2 mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="porfolio-card-wrapper">
                      <div class="portfolioCard">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="portfolio-content">
                              <div class="portfolio-content-top">
                                <h2>
                                  <a href="portfolio-details.html">
                                    Centralized Product Management
                                  </a>
                                </h2>
                                <p>
                                  Streamline your operations with our robust
                                  product database. Effortlessly manage SKUs,
                                  categories, and stock status through a
                                  high-performance interface designed for speed
                                  and accuracy in the Australian market.
                                </p>
                                <ul>
                                  <li>CRM Module</li>
                                  <li>Products Management</li>
                                </ul>
                              </div>
                              <div class="portfolio-content-btm">
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setOpen(true);
                                  }}
                                  class="view-details-btn"
                                >
                                  Get A Demo
                                  <svg
                                    class="arrow"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z"></path>
                                    </g>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="portfolio-img">
                              <img src="assets/pro-1.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="portfolioCard two">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="portfolio-content">
                              <div class="portfolio-content-top">
                                <h2>
                                  <a href="portfolio-details.html">
                                    Seamless Workflow Automation
                                  </a>
                                </h2>
                                <p>
                                  Optimize your field operations with our
                                  advanced job management system. Assign
                                  installers, track real-time job statuses, and
                                  manage time slots with precision. Insight Wide
                                  ensures your team stays organized and your
                                  clients receive timely service, every single
                                  time.
                                </p>
                                <ul>
                                  <li>Job Management</li>
                                  <li>Field Service</li>
                                </ul>
                              </div>
                              <div class="portfolio-content-btm">
                                <a
                                  href="portfolio-details.html"
                                  class="view-details-btn"
                                >
                                  Get A Demo
                                  <svg
                                    class="arrow"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z"></path>
                                    </g>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="portfolio-img">
                              <img src="assets/pro-2.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="portfolioCard three">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="portfolio-content">
                              <div class="portfolio-content-top">
                                <h2>
                                  <a href="portfolio-details.html">
                                    Stock Control & Analytics
                                  </a>
                                </h2>
                                <p>
                                  Streamline your logistics with an intuitive
                                  overview of your entire stock ecosystem. From
                                  detailed movement logs to installer-specific
                                  stock tracking, our platform simplifies
                                  complex inventory tasks, allowing you to focus
                                  on scaling your business with confidence.
                                </p>
                                <ul>
                                  <li>Logistics Control</li>
                                  <li>Supply Chain</li>
                                </ul>
                              </div>
                              <div class="portfolio-content-btm">
                                <a
                                  href="portfolio-details.html"
                                  class="view-details-btn"
                                >
                                  Get A Demo
                                  <svg
                                    class="arrow"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z"></path>
                                    </g>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="portfolio-img">
                              <img src="assets/pro-3.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="portfolioCard four">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="portfolio-content">
                              <div class="portfolio-content-top">
                                <h2>
                                  <a href="portfolio-details.html">
                                    Estimates & Quote Management
                                  </a>
                                </h2>
                                <p>
                                  Accelerate your sales cycle with Insight
                                  Wide’s streamlined estimation tool. Create,
                                  send, and track professional quotes with ease.
                                  Monitor every deal’s status in real-time—from
                                  draft to acceptance—and provide your clients
                                  with clear and detailed breakdowns of
                                  components
                                </p>
                                <ul>
                                  <li>Revenue Tracking</li>
                                  <li>Quote Automation</li>
                                </ul>
                              </div>
                              <div class="portfolio-content-btm">
                                <a
                                  href="portfolio-details.html"
                                  class="view-details-btn"
                                >
                                  Get A Demo
                                  <svg
                                    class="arrow"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z"></path>
                                    </g>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="portfolio-img">
                              <img src="assets/pro-4.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="home2-process-section mb-120">
              <div className="container">
                <div className="process-wrapper">
                  <div className="row justify-content-center">
                    <div className="col-lg-6 mb-80">
                      <div className="section-title text-center two">
                        <span>Solutions Steps</span>
                        <h2 className="text-anim">
                          How We Transform Challenges Solutions
                        </h2>
                        <p className="text-anim">
                          How we craft innovative solutions step by step
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="process-slider-area">
                    <svg
                      className="line"
                      width="1320"
                      height="6"
                      viewBox="0 0 1320 6"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M5 2.38696L-2.52368e-07 0.000211477L2.52368e-07 5.77371L5 3.38696L5 2.38696ZM1315 3.38685L1320 5.7736L1320 9.60792e-05L1315 2.38685L1315 3.38685ZM4.5 2.88696L4.5 3.38696L1315.5 3.38685L1315.5 2.88685L1315.5 2.38685L4.5 2.38696L4.5 2.88696Z" />
                    </svg>
                    <div className="row justify-content-center">
                      <div className="col-lg-12">
                        <div className="swiper home1-process-slider">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide">
                              <div className="process-card">
                                <div className="step-no-and-icon">
                                  <span>Step-01 :</span>
                                  <div className="icon">
                                    <i className="bi bi-check-lg"></i>
                                  </div>
                                </div>
                                <div className="process-content">
                                  <h3>
                                    Discovery & <br />
                                    Consultation
                                  </h3>
                                  <p>
                                    We begin by understanding your unique
                                    business challenges. Our experts analyze
                                    your current workflows to identify how
                                    Insight Wide or a custom solution can drive
                                    growth.
                                  </p>
                                  <ul>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Business Audit
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Need Gap Analysis
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Personalized Strategy
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="swiper-slide">
                              <div className="process-card">
                                <div className="step-no-and-icon">
                                  <span>Step-02 :</span>
                                  <div className="icon">
                                    <i className="bi bi-check-lg"></i>
                                  </div>
                                </div>
                                <div className="process-content">
                                  <h3>
                                    Solution
                                    <br />
                                    Architecture
                                  </h3>
                                  <p>
                                    Based on your needs, we map out the perfect
                                    fit—whether it’s our core Insight Wide CRM
                                    or a fully bespoke software tailored
                                    specifically for your Melbourne-based
                                    operations.
                                  </p>
                                  <ul>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Feature Mapping
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      System Design
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Scalability Planning
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="swiper-slide">
                              <div className="process-card">
                                <div className="step-no-and-icon">
                                  <span>Step-03 :</span>
                                  <div className="icon">
                                    <i className="bi bi-check-lg"></i>
                                  </div>
                                </div>
                                <div className="process-content">
                                  <h3>
                                    UI/UX & <br />
                                    Prototyping
                                  </h3>
                                  <p>
                                    Experience the visual journey before we
                                    build. We design clean, high-fidelity
                                    wireframes that focus on user ease, ensuring
                                    the interface is intuitive for your entire
                                    team.
                                  </p>
                                  <ul>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      User Flow Design
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Interactive Prototypes
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Brand Alignment
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="swiper-slide">
                              <div className="process-card">
                                <div className="step-no-and-icon">
                                  <span>Step-04 :</span>
                                  <div className="icon">
                                    <i className="bi bi-check-lg"></i>
                                  </div>
                                </div>
                                <div className="process-content">
                                  <h3>
                                    Agile <br />
                                    Development
                                  </h3>
                                  <p>
                                    Our developers bring the blueprint to life.
                                    Using a modern tech stack, we build secure,
                                    robust modules with regular updates so
                                    you’re always in the loop.
                                  </p>
                                  <ul>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Clean Code Standards
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Regular Progress Syncs
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Module Integration
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="swiper-slide">
                              <div className="process-card">
                                <div className="step-no-and-icon">
                                  <span>Step-05 :</span>
                                  <div className="icon">
                                    <i className="bi bi-check-lg"></i>
                                  </div>
                                </div>
                                <div className="process-content">
                                  <h3>
                                    Deployment & <br />
                                    Support
                                  </h3>
                                  <p>
                                    We launch your solution with a flexible
                                    subscription model that fits your budget.
                                    Our relationship doesn't end at launch; we
                                    provide ongoing support to ensure your
                                    long-term success.
                                  </p>
                                  <ul>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Seamless Go-Live
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Team Training
                                    </li>
                                    <li>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="8" cy="8" r="8" />
                                        <g>
                                          <path d="M10.7565 5.20404C10.8947 5.07172 11.0787 4.99857 11.2695 5.00002C11.4604 5.00147 11.6433 5.07742 11.7795 5.21183C11.9157 5.34624 11.9947 5.5286 11.9997 5.72044C12.0048 5.91228 11.9355 6.09858 11.8065 6.24004L7.89085 11.1635C7.82352 11.2364 7.74226 11.2949 7.65192 11.3355C7.56158 11.3761 7.46403 11.398 7.36509 11.3999C7.26614 11.4017 7.16785 11.3835 7.07608 11.3463C6.98431 11.309 6.90094 11.2536 6.83097 11.1832L4.23426 8.57251C4.16195 8.50477 4.10395 8.42307 4.06372 8.3323C4.02349 8.24153 4.00186 8.14354 4.00011 8.04418C3.99837 7.94482 4.01655 7.84612 4.05357 7.75398C4.09059 7.66184 4.14569 7.57813 4.21558 7.50787C4.28547 7.4376 4.36872 7.3822 4.46037 7.34498C4.55202 7.30777 4.65019 7.28949 4.74901 7.29124C4.84784 7.29299 4.9453 7.31474 5.03559 7.35519C5.12588 7.39563 5.20713 7.45395 5.27452 7.52665L7.32951 9.59174L10.7378 5.22575C10.744 5.21816 10.7495 5.21091 10.7565 5.20404Z" />
                                        </g>
                                      </svg>
                                      Ongoing Maintenance
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
